/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type IGetAssetsCountQueryVariables = Types.Exact<{
  softwareEscrowId: Types.Scalars['ID']['input'];
  type?: Types.InputMaybe<Types.AssetTypeEnum>;
}>;

export type IGetAssetsCountQuery = { __typename?: 'Query'; assets: { __typename?: 'AssetPage'; nodesCount: number } };

export const GetAssetsCountDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getAssetsCount' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'softwareEscrowId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'type' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'AssetTypeEnum' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assets' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'softwareEscrowId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'softwareEscrowId' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'type' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'type' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'nodesCount' } }],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IGetAssetsCountQuery, IGetAssetsCountQueryVariables>;
